/**
 * @file Common data layer helper.
 */

(function ($) {
  if (typeof DataLayerHelper !== 'undefined') {
    let helper = new DataLayerHelper(dataLayer);
    let topicObj = helper.get('entityTaxonomy.taxonomy_topic');
    if (typeof topicObj !== 'undefined') {
      let firstKey = Object.keys(topicObj)[0];
      if (typeof topicsJSON[topicObj[firstKey]] !== 'undefined') {
        // console.log(topicObj[firstKey]);
        // console.log(topicsJSON[topicObj[firstKey]]);
        // console.log(dataLayer[0].entityTaxonomy);
        dataLayer[0].entityTaxonomy['topicParent'] = topicsJSON[topicObj[firstKey]];
      }
    }
  }
})(jQuery);
